"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolPlace = void 0;
const Place_1 = require("./Place");
const Result_type_1 = require("../../types/Result.type");
const SurveyObjectUnserializer_1 = require("./SurveyObjectUnserializer");
/**
 * SchoolPlace place class for person usual school locations
 * Represents the primary school location of a person
 * This is an alias of Place with custom validation display name
 */
class SchoolPlace extends Place_1.Place {
    constructor(dirtyParams, surveyObjectsRegistry) {
        super(dirtyParams, surveyObjectsRegistry);
    }
    /**
     * Creates a SchoolPlace object from sanitized parameters
     * @param {ExtendedPlaceAttributes | SerializedExtendedPlaceAttributes} params - Sanitized place parameters
     * @returns {SchoolPlace} New SchoolPlace instance
     */
    static unserialize(params, surveyObjectsRegistry) {
        const flattenedParams = SurveyObjectUnserializer_1.SurveyObjectUnserializer.flattenSerializedData(params);
        return new SchoolPlace(flattenedParams, surveyObjectsRegistry);
    }
    /**
     * Factory that validates input and creates a SchoolPlace object
     * @param {Object} dirtyParams - Raw input parameters to validate
     * @returns {Result<SchoolPlace>} Either a valid SchoolPlace object or validation errors
     */
    static create(dirtyParams, surveyObjectsRegistry) {
        const errors = Place_1.Place.validateParams(dirtyParams, 'SchoolPlace');
        const schoolPlace = errors.length === 0
            ? new SchoolPlace(dirtyParams, surveyObjectsRegistry)
            : undefined;
        if (errors.length > 0) {
            return (0, Result_type_1.createErrors)(errors);
        }
        return (0, Result_type_1.createOk)(schoolPlace);
    }
}
exports.SchoolPlace = SchoolPlace;
//# sourceMappingURL=SchoolPlace.js.map